const resultCardsCss = [
    {src: "♦", card_rank : "A", rsc_val : 'AD'},
    {src: "♣", card_rank : "A", rsc_val : 'AC' },
    {src: "♥", card_rank : "A", rsc_val : 'AH' },
    {src: "♠", card_rank : "A", rsc_val : 'AS' },
    {src: "♦", card_rank : "2", rsc_val : '2D' },
    {src: "♣", card_rank : "2", rsc_val : '2C' },
    {src: "♥", card_rank : "2", rsc_val : '2H' },
    {src: "♠", card_rank : "2", rsc_val : '2S' },
    {src: "♦", card_rank : "3", rsc_val : '3D' },
    {src: "♣", card_rank : "3", rsc_val : '3C' },
    {src: "♥", card_rank : "3", rsc_val : '3H' },
    {src: "♠", card_rank : "3", rsc_val : '3S' },
    {src: "♦", card_rank : "4", rsc_val : '4D' },
    {src: "♣", card_rank : "4", rsc_val : '4C' },
    {src: "♥", card_rank : "4", rsc_val : '4H' },
    {src: "♠", card_rank : "4", rsc_val : '4S' },
    {src: "♦", card_rank : "5", rsc_val : '5D' },
    {src: "♣", card_rank : "5", rsc_val : '5C' },
    {src: "♥", card_rank : "5", rsc_val : '5H' },
    {src: "♠", card_rank : "5", rsc_val : '5S' },
    {src: "♦", card_rank : "6", rsc_val : '6D' },
    {src: "♣", card_rank : "6", rsc_val : '6C' },
    {src: "♥", card_rank : "6", rsc_val : '6H' },
    {src: "♠", card_rank : "6", rsc_val : '6S' },
    {src: "♦", card_rank : "7", rsc_val : '7D' },
    {src: "♣", card_rank : "7", rsc_val : '7C' },
    {src: "♥", card_rank : "7", rsc_val : '7H' },
    {src: "♠", card_rank : "7", rsc_val : '7S' },
    {src: "♦", card_rank : "8", rsc_val : '8D' },
    {src: "♣", card_rank : "8", rsc_val : '8C' },
    {src: "♥", card_rank : "8", rsc_val : '8H' },
    {src: "♠", card_rank : "8", rsc_val : '8S' },
    {src: "♦", card_rank : "9", rsc_val : '9D' },
    {src: "♣", card_rank : "9", rsc_val : '9C' },
    {src: "♥", card_rank : "9", rsc_val : '9H' },
    {src: "♠", card_rank : "9", rsc_val : '9S' },
    {src: "♦", card_rank : "10", rsc_val : '10D'},
    {src: "♣", card_rank : "10", rsc_val : '10C'},
    {src: "♥", card_rank : "10", rsc_val : '10H'},
    {src: "♠", card_rank : "10", rsc_val : '10S'},
    {src: "♦", card_rank : "J", rsc_val : 'JD' },
    {src: "♣", card_rank : "J", rsc_val : 'JC' },
    {src: "♥", card_rank : "J", rsc_val : 'JH' },
    {src: "♠", card_rank : "J", rsc_val : 'JS' },
    {src: "♦", card_rank : "Q", rsc_val : 'QD' },
    {src: "♣", card_rank : "Q", rsc_val : 'QC' },
    {src: "♥", card_rank : "Q", rsc_val : 'QH' },
    {src: "♠", card_rank : "Q", rsc_val : 'QS' },
    {src: "♦", card_rank : "K", rsc_val : 'KD' },
    {src: "♣", card_rank : "K", rsc_val : 'KC' },
    {src: "♥", card_rank : "K", rsc_val : 'KH' },
    {src: "♠", card_rank : "K", rsc_val : 'KS' },
     
]

export default resultCardsCss;